<template>
  <header class="header">
    <div class="header-inner">
      <!-- 替换为图片logo -->
      <div class="logo-container">
        <img src="@/assets/logo-big.png" alt="胥大科技" class="logo-img">
      </div>
      <nav class="nav" :class="{ open: menuOpen }">
        <router-link to="/" exact-active-class="active">首页</router-link>
        <router-link to="/product" exact-active-class="active">产品中心</router-link>
        <router-link to="/solution" exact-active-class="active">解决方案</router-link>
        <router-link to="/about" exact-active-class="active">关于我们</router-link>
      </nav>
      <div class="hamburger" @click="menuOpen = true">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="menuOpen" class="mobile-menu">
        <div class="mobile-header">
          <!-- 移动端图片logo -->
          <div class="logo-container">
            <img src="@/assets/logo-big.png" alt="胥大科技" class="logo-img">
          </div>
          <button class="close-btn" @click="menuOpen = false">×</button>
        </div>
        <div class="mobile-nav">
          <router-link to="/" @click="menuOpen = false" exact-active-class="active">首页</router-link>
          <router-link to="/product" @click="menuOpen = false" exact-active-class="active">产品中心</router-link>
          <router-link to="/solution" @click="menuOpen = false" exact-active-class="active">解决方案</router-link>
          <router-link to="/about" @click="menuOpen = false" exact-active-class="active">关于我们</router-link>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="menuOpen" class="menu-mask" @click="menuOpen = false"></div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      menuOpen: false,
    };
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;


  .header-inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    padding: 0 32px;

    // 图片logo容器样式
    .logo-container {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .logo-img {
      height: 40px; // 控制logo高度，保持比例
      width: auto;  // 自动宽度，保持图片比例
      object-fit: contain; // 确保图片完整显示
    }

    .nav {
      display: flex;
      gap: 36px;

      a {
        color: #222;
        font-size: 17px;
        font-weight: 500;
        text-decoration: none;
        transition: color 0.2s;
        position: relative;
        padding: 8px 0;

        &.active, &:hover {
          color: #1769fa;
        }

        // 活跃状态下划线
        &.active:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: #1769fa;
          border-radius: 1px;
        }
      }
    }

    .hamburger {
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      cursor: pointer;
      margin-left: 16px;

      .bar {
        width: 28px;
        height: 3px;
        background: #1769fa;
        margin: 4px 0;
        border-radius: 2px;
        transition: all 0.3s;
      }
    }
  }

  .menu-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.25);
    z-index: 999;
  }

  .mobile-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    z-index: 1001;
    display: flex;
    flex-direction: column;
    animation: slideInMenu 0.4s cubic-bezier(0.4,0,0.2,1);

    .mobile-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 64px;
      padding: 0 24px;
      border-bottom: 1px solid #f0f0f0;

      // 移动端logo样式
      .logo-img {
        height: 36px; // 稍小于桌面端
        width: auto;
      }

      .close-btn {
        background: none;
        border: none;
        font-size: 32px;
        color: #222;
        cursor: pointer;
        line-height: 1;
        padding: 0 8px;
      }
    }

    .mobile-nav {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      gap: 32px;

      a {
        color: #222;
        font-size: 22px;
        font-weight: 500;
        text-decoration: none;
        transition: color 0.2s;

        &.active, &:hover {
          color: #1769fa;
        }
      }
    }
  }

  @media (max-width: 900px) {
    .header-inner {
      padding: 0 12px;

      .nav {
        display: none;
      }

      .hamburger {
        display: flex;
      }
    }
  }
}

// 动画效果
@keyframes slideInMenu {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 过渡动画样式
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
